import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
export const APPROVER_LIST = "approverList";

export function fetchApproversIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
          APPROVER_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findApprovers();
        },
        force
      )
    );
  };
}
